export default __webpack_public_path__ + "static/media/O-046.67acf441.png";